import * as Fetch from "../../utils/Fetch"

export interface IUserAuthorizationTableRow {
	id: number,
	name: string,
	kind: string,
	label: string,
	authorizationLevel: string,
	expirationDate: string,
	inceptionDate: string,
	issueId: number,
	relationId: number,
	resourceStatus: string,
	relationStatus: string,
	relationNumber: string,
}

export interface IUserAuthorizationData {
	forDataSet: IUserAuthorizationDataRow[],
	forBusinessProcess: IUserAuthorizationDataRow[],
}

export interface IUserAuthorizationLoadingData {
	forDataSet: boolean,
	forBusinessProcess: boolean,
}

export interface IUserAuthorizationDataRow extends IUserAuthorizationTableRow {
	period: string,
}

export interface IDictionary<TValue> {
	[id: number]: TValue;
}

interface IRelatedAuthorizationJsonData {
	Kind: string,
	Name: string,
	Label: string,
	Type: string,
	ExpirationDate: string,
	ResourceId: number,
	InceptionDate: string,
	IssueId?: number,
	RelationId: number,
	AuthorizationLevel: string,
	ResourceStatus: string,
	RelationStatus: string,
	RelationNumber: string,
}

export default class AuthUserAuthorizationsService {
	getRelatedDataSetsResources(
		userId: string,
		filterId: string,
		filterExpression: string,
		logFilters: string,
		setRowsPerUsers: (result: IUserAuthorizationDataRow[]) => void)
	{
		Fetch.get<any>("/ResourceRelations/GetRelatedDataSetsResources", {
			userId: userId,
			filterId: filterId,
			filterExpression: filterExpression,
			filters: logFilters,
		})
			.then(data => {
				if (data.success) {
					var result = data.rows.map((source: IRelatedAuthorizationJsonData) => {
						let target: IUserAuthorizationDataRow = this.mapping(source);

						return target;
					});
					setRowsPerUsers(result);
					return;
				}
				console.error("Nie udało się pobrać danych.");
				setRowsPerUsers(null);
			});
	}

	private mapping(source: IRelatedAuthorizationJsonData): IUserAuthorizationDataRow {
        return {
            authorizationLevel: source.AuthorizationLevel,
            expirationDate: source.ExpirationDate,
            id: source.ResourceId,
            inceptionDate: source.InceptionDate,
            issueId: source.IssueId,
            kind: source.Kind,
            label: source.Label,
            name: source.Name,
            relationId: source.RelationId,
            relationStatus: source.RelationStatus,
            resourceStatus: source.ResourceStatus,
			period: source.InceptionDate,
			relationNumber: source.RelationNumber
        };
    }

	getRelatedBusinessProcessResources(userId: string, filterId: string, logFilters: string, setRowsPerUsers: (result: IUserAuthorizationDataRow[]) => void) {
		Fetch.get<any>("/ResourceRelations/GetRelatedBusinessProcessResources", {
			userId: userId,
			filterId: filterId,
			filters: logFilters,
		})
			.then(data => {
				if (data.success) {
					var result = data.rows.map((source: IRelatedAuthorizationJsonData) => {
						let target: IUserAuthorizationDataRow = this.mapping(source);

						return target;
					});
					setRowsPerUsers(result);
					return;
				}
				console.error("Nie udało się pobrać danych.");
				setRowsPerUsers(null);
			});
	}
}